
$(document).ready(function(){
  setTimeout(function(){   // 2 second delay
    $('.styling-blocks').each(function() {
      $(this).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        centerMode: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: { slidesToShow: 1,   dots: false,
        arrows: false }
          },
          {
            breakpoint: 768,
            settings: { slidesToShow: 1,   dots: true,
        arrows: false }
          }
        ]
      });
    });
  }, 2000); // 2 second delay
});
